var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-layout"},[(_vm.hasHead)?_c('sev-head'):_vm._e(),_c('div',{staticClass:"base-content"},[(_vm.unSlideFade)?_c('router-view'):_c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }